import React, { useState, ChangeEvent, useEffect } from 'react'
import { inject, observer } from 'mobx-react'
import { RouteProps } from 'react-router'
import { WithTranslation, withTranslation } from 'react-i18next'
import { Button, FormControl, InputLabel, Typography, OutlinedInput, InputAdornment, IconButton, FormHelperText } from '@material-ui/core'
import { Visibility, VisibilityOff } from '@material-ui/icons'
import AuthStore from '../../../../stores/auth.store'
import googleLogo from './../../../../assets/images/google-logo.png'
import './../auth.style.scss'

interface LogInProps extends RouteProps, WithTranslation {
    authStore?: AuthStore
}

const LogInComponent: React.FC<LogInProps> = ({ t, authStore }) => {
    const [showPassword, setShowPassword] = useState(false)
    const [error, setError] = useState<string | null>(null)

    useEffect(() => {
        return () => {
            // Clear only the password on unmount
            authStore?.updateSignInData('password', '')
        }
    }, [authStore])

    const onChange = (prop: 'email' | 'password', event: ChangeEvent<HTMLInputElement>) => {
        const { value } = event.target
        authStore?.updateSignInData(prop, value)
    }

    const handleLogin = async () => {
        try {
            await authStore?.logIn()
        } catch (e: any) {
            setError(e.message)
        }
    }

    const { email, password } = authStore!.signInObject

    return (
        <form className={'signin-form'} noValidate autoComplete="on">
            <Typography className="welcome-message" variant="h6">
                {t('welcome')}
            </Typography>

            <FormControl variant="outlined" fullWidth className={'input'} required error={!!error}>
                <InputLabel htmlFor="email-input">{t('email')}</InputLabel>
                <OutlinedInput
                    id="email-input"
                    value={email}
                    onChange={(e: ChangeEvent<HTMLInputElement>) => onChange('email', e)}
                    type="email"
                    label={t('email')}
                />
            </FormControl>

            <FormControl variant="outlined" fullWidth className={'input'} required error={!!error}>
                <InputLabel htmlFor="password-input">{t('password')}</InputLabel>
                <OutlinedInput
                    id="password-input"
                    value={password}
                    onChange={(e: ChangeEvent<HTMLInputElement>) => onChange('password', e)}
                    type={showPassword ? 'text' : 'password'}
                    label={t('password')}
                    endAdornment={
                        <InputAdornment position="end">
                            <IconButton aria-label="toggle password visibility" onClick={() => setShowPassword(!showPassword)} edge="end">
                                {showPassword ? <VisibilityOff /> : <Visibility />}
                            </IconButton>
                        </InputAdornment>
                    }
                />
                {error && <FormHelperText error>{error}</FormHelperText>}
            </FormControl>

            <Button fullWidth disabled={!email || !password} onClick={handleLogin} className="login-botton">
                {t('login')}
            </Button>

            <div className="or-divider">
                <span>{t('or')}</span>
            </div>

            <Button fullWidth onClick={authStore!.logInUsingGoogle} className="login-button" endIcon={<img src={googleLogo} alt="" width={20} />}>
                {t('loginWithGoogle')}
            </Button>
        </form>
    )
}

export default withTranslation('authScreen')(inject('authStore')(observer(LogInComponent)))
